import { gql, useMutation } from '@apollo/client'
import { path } from 'ramda'
import { useNotification } from '@btime/react-messager'
import { useSessionPermission } from '@btime/react-session'
import React from 'react'

import { formsClient } from '../../utils/apollo/api'
import Editable from '../../packages/kiti/components/form/Editable'

const MUTATION = gql`
  mutation UpsertForm($input: FormInput) {
    upsertForm(input: $input) {
      id
    }
  }
`

const cleanRequest = (field, value) => {
  switch (field) {
    case 'checklist':
      return { checklistId: value?.id }
    default:
      return { [field]: value }
  }
}

const EditableForm = ({ record, field, children, ...props }) => {
  const canEdit = useSessionPermission('editForm')
  const notify = useNotification()
  const [request, { loading }] = useMutation(MUTATION, { refetchQueries: ['Forms'], client: formsClient })

  const handleRequest = value => {
    const params = {
      variables: {
        input: { id: record.id, name: record.name, checklistId: record.checklist.id, ...cleanRequest(field, value) }
      }
    }
    return request(params).then(resp => {
      if (!!resp.errors) {
        notify.error({ title: 'Ocorreu um erro ao salvar!', message: path(['errors', 0, 'message'], resp) })
      }
    })
  }

  return (
    <Editable value={record[field]} onSubmit={handleRequest} loading={loading} disabled={!canEdit} {...props}>
      {children}
    </Editable>
  )
}

export default EditableForm
